// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Some overrides to apply our styles */
.react-datepicker {
  --tw-border-opacity: 1;
  border-color: rgba(243, 244, 246, 1);
  border-color: rgba(243, 244, 246, var(--tw-border-opacity));
  --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}

.react-datepicker__header {
  --tw-bg-opacity: 1;
  background-color: rgba(249, 250, 251, 1);
  background-color: rgba(249, 250, 251, var(--tw-bg-opacity));
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-bottom-color: rgba(243, 244, 246, 1);
  border-bottom-color: rgba(243, 244, 246, var(--tw-border-opacity));
}

.react-datepicker__day--keyboard-selected,
.react-datepicker__month-text--keyboard-selected,
.react-datepicker__quarter-text--keyboard-selected,
.react-datepicker__year-text--keyboard-selected {
  --tw-bg-opacity: 1;
  background-color: rgba(29, 78, 216, 1);
  background-color: rgba(29, 78, 216, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.react-datepicker__today-button {
  --tw-bg-opacity: 1;
  background-color: rgba(249, 250, 251, 1);
  background-color: rgba(249, 250, 251, var(--tw-bg-opacity));
  --tw-border-opacity: 1;
  border-top-color: rgba(243, 244, 246, 1);
  border-top-color: rgba(243, 244, 246, var(--tw-border-opacity));
  font-weight: 600;
}

/* Render a arrow up and down in the year dropdown */
.react-datepicker__year-dropdown {
  --tw-bg-opacity: 1;
  background-color: rgba(249, 250, 251, 1);
  background-color: rgba(249, 250, 251, var(--tw-bg-opacity));
  --tw-border-opacity: 1;
  border-color: rgba(229, 231, 235, 1);
  border-color: rgba(229, 231, 235, var(--tw-border-opacity));
}

.react-datepicker__year-option:hover,
.react-datepicker__month-option:hover,
.react-datepicker__month-year-option:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, 1);
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}

.react-datepicker__navigation--years-upcoming,
.react-datepicker__navigation--years-previous {
  position: relative;
  height: 1.5rem;
}

.react-datepicker__year-option .react-datepicker__navigation--years-upcoming:before {
  content: '';
  position: absolute;
  top: 12px;
  left: 8px;
  border-bottom-width: 8px;
  --tw-border-opacity: 1;
  border-bottom-color: rgba(107, 114, 128, 1);
  border-bottom-color: rgba(107, 114, 128, var(--tw-border-opacity));
  border-left-width: 8px;
  border-left-color: transparent;
  border-right-width: 8px;
  border-right-color: transparent;
}

.react-datepicker__year-option .react-datepicker__navigation--years-upcoming:after {
  content: '';
  position: absolute;
  top: 13px;
  left: 9px;
  border-bottom-width: 7px;
  --tw-border-opacity: 1;
  border-bottom-color: rgba(249, 250, 251, 1);
  border-bottom-color: rgba(249, 250, 251, var(--tw-border-opacity));
  border-left-width: 7px;
  border-left-color: transparent;
  border-right-width: 7px;
  border-right-color: transparent;
}


.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming:after {
  --tw-border-opacity: 1;
  border-bottom-color: rgba(229, 231, 235, 1);
  border-bottom-color: rgba(229, 231, 235, var(--tw-border-opacity));
}

.react-datepicker__year-option .react-datepicker__navigation--years-previous:before {
  content: '';
  position: absolute;
  top: 5px;
  left: 8px;
  border-top-width: 8px;
  --tw-border-opacity: 1;
  border-top-color: rgba(107, 114, 128, 1);
  border-top-color: rgba(107, 114, 128, var(--tw-border-opacity));
  border-left-width: 8px;
  border-left-color: transparent;
  border-right-width: 8px;
  border-right-color: transparent;
}

.react-datepicker__year-option .react-datepicker__navigation--years-previous:after {
  content: '';
  position: absolute;
  top: 5px;
  left: 9px;
  border-top-width: 7px;
  --tw-border-opacity: 1;
  border-top-color: rgba(249, 250, 251, 1);
  border-top-color: rgba(249, 250, 251, var(--tw-border-opacity));
  border-left-width: 7px;
  border-left-color: transparent;
  border-right-width: 7px;
  border-right-color: transparent;
}

.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous:after {
  --tw-border-opacity: 1;
  border-top-color: rgba(229, 231, 235, 1);
  border-top-color: rgba(229, 231, 235, var(--tw-border-opacity));
}`, "",{"version":3,"sources":["webpack://./src/ui/Inputs/DateInput/Styles.css"],"names":[],"mappings":"AAAA,uCAAuC;AAErC;EAAA,sBAAsB;EAAtB,oCAAsB;EAAtB,2DAAsB;EACtB,mFAAgB;EAAhB,mGAAgB;EAAhB,wHAAgB;EAAhB;AADsB;;AAKtB;EAAA,kBAAiB;EAAjB,wCAAiB;EAAjB,2DAAiB;EACjB,wBAAe;EACf,sBAAwB;EAAxB,2CAAwB;EAAxB;AAFiB;;AASjB;;;;EAAA,kBAAkB;EAAlB,sCAAkB;EAAlB,yDAAkB;EAClB,oBAAiB;EAAjB,6BAAiB;EAAjB;AADkB;;AAKlB;EAAA,kBAAiB;EAAjB,wCAAiB;EAAjB,2DAAiB;EACjB,sBAAwB;EAAxB,wCAAwB;EAAxB,+DAAwB;EACxB;AAFiB;;AAKnB,oDAAoD;AAElD;EAAA,kBAAiB;EAAjB,wCAAiB;EAAjB,2DAAiB;EACjB,sBAAsB;EAAtB,oCAAsB;EAAtB;AADiB;;AAOjB;;;EAAA,kBAAkB;EAAlB,wCAAkB;EAAlB;AAAkB;;AAKlB;;EAAA,kBAAe;EACf;AADe;;AAIjB;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,wBAAuC;EAAvC,sBAAuC;EAAvC,2CAAuC;EAAvC,kEAAuC;EACvC,sBAA0C;EAA1C,8BAA0C;EAC1C,uBAA0C;EAA1C,+BAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,wBAAsC;EAAtC,sBAAsC;EAAtC,2CAAsC;EAAtC,kEAAsC;EACtC,sBAA0C;EAA1C,8BAA0C;EAC1C,uBAA0C;EAA1C,+BAA0C;AAC5C;;;AAIE;EAAA,sBAAwB;EAAxB,2CAAwB;EAAxB;AAAwB;;AAG1B;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,qBAAuC;EAAvC,sBAAuC;EAAvC,wCAAuC;EAAvC,+DAAuC;EACvC,sBAA0C;EAA1C,8BAA0C;EAC1C,uBAA0C;EAA1C,+BAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,qBAAsC;EAAtC,sBAAsC;EAAtC,wCAAsC;EAAtC,+DAAsC;EACtC,sBAA0C;EAA1C,8BAA0C;EAC1C,uBAA0C;EAA1C,+BAA0C;AAC5C;;AAGE;EAAA,sBAAwB;EAAxB,wCAAwB;EAAxB;AAAwB","sourcesContent":["/* Some overrides to apply our styles */\n.react-datepicker {\n  @apply border-gray-100;\n  @apply shadow-lg;\n}\n\n.react-datepicker__header {\n  @apply bg-gray-50;\n  @apply border-b;\n  @apply border-b-gray-100;\n}\n\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected {\n  @apply bg-blue-700;\n  @apply text-white;\n}\n\n.react-datepicker__today-button {\n  @apply bg-gray-50;\n  @apply border-t-gray-100;\n  @apply font-semibold;\n}\n\n/* Render a arrow up and down in the year dropdown */\n.react-datepicker__year-dropdown {\n  @apply bg-gray-50;\n  @apply border-gray-200;\n}\n\n.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover,\n.react-datepicker__month-year-option:hover {\n  @apply bg-gray-200;\n}\n\n.react-datepicker__navigation--years-upcoming,\n.react-datepicker__navigation--years-previous {\n  @apply relative;\n  @apply h-6;\n}\n\n.react-datepicker__year-option .react-datepicker__navigation--years-upcoming:before {\n  content: '';\n  position: absolute;\n  top: 12px;\n  left: 8px;\n  @apply border-b-[8px] border-b-gray-500;\n  @apply border-l-[8px] border-l-transparent;\n  @apply border-r-[8px] border-r-transparent;\n}\n\n.react-datepicker__year-option .react-datepicker__navigation--years-upcoming:after {\n  content: '';\n  position: absolute;\n  top: 13px;\n  left: 9px;\n  @apply border-b-[7px] border-b-gray-50;\n  @apply border-l-[7px] border-l-transparent;\n  @apply border-r-[7px] border-r-transparent;\n}\n\n\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming:after {\n  @apply border-b-gray-200;\n}\n\n.react-datepicker__year-option .react-datepicker__navigation--years-previous:before {\n  content: '';\n  position: absolute;\n  top: 5px;\n  left: 8px;\n  @apply border-t-[8px] border-t-gray-500;\n  @apply border-l-[8px] border-l-transparent;\n  @apply border-r-[8px] border-r-transparent;\n}\n\n.react-datepicker__year-option .react-datepicker__navigation--years-previous:after {\n  content: '';\n  position: absolute;\n  top: 5px;\n  left: 9px;\n  @apply border-t-[7px] border-t-gray-50;\n  @apply border-l-[7px] border-l-transparent;\n  @apply border-r-[7px] border-r-transparent;\n}\n\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous:after {\n  @apply border-t-gray-200;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
